import { gunzipSync } from 'fflate';

/** Some static servers decode Content-Encoding before returning the body. */
export function decodePdfFont(input: Uint8Array): Uint8Array {
  const bytes = input[0] === 0x1f && input[1] === 0x8b ? gunzipSync(input) : input;
  if (bytes.length !== 2054744 || bytes[0] !== 0 || bytes[1] !== 1 || bytes[2] !== 0 || bytes[3] !== 0) {
    throw new Error('PDF 글꼴 파일을 확인하지 못했어요. 다시 준비해 주세요.');
  }
  return bytes;
}
